import * as swcHelpers from '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import { useBloomreachPageModels } from './use-bloomreach-page-models.js';

function useBloomreachPageRoutes() {
    const page = useBrPageContext();
    const pageModels = useBloomreachPageModels();
    const pageRoutes = pageModels === null || pageModels === void 0 ? void 0 : pageModels.routes;
    if (!pageRoutes) {
        return {
            routes: {}
        };
    }
    // In the new version of bloomreach in preview mode the params that
    // are added by the bloomreach API can cause issues for the root routes sometimes
    // because these are base routes that are usually joined with other paths
    let cleanedRoutes = pageRoutes;
    if (page.isPreview()) {
        cleanedRoutes = Object.keys(pageRoutes).reduce((acc, key)=>{
            const route = pageRoutes[key].split('?')[0];
            return swcHelpers.objectSpread({}, acc, {
                [key]: route !== null && route !== void 0 ? route : ''
            });
        }, {});
    }
    return {
        routes: cleanedRoutes
    };
}

export { useBloomreachPageRoutes };
//# sourceMappingURL=use-bloomreach-page-routes.js.map
